import React, { useState } from "react";
import "./Header.css";
import logo from "../assets/images/Elogo.jpeg";
import { FaChevronDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import axios from "axios";
import { HostApi } from "../configuration";
// import companypdf from "../pdf/CompanyProfile_E-Advisor.pdf";
import {
    FaWhatsapp,
    FaFacebook,
    FaInstagram,
    FaTwitter,
    FaLinkedin,
    FaSearch, FaPhone, FaEnvelope
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [openMenu, setOpenMenu] = useState(null);
    const [openSubMenu, setOpenSubMenu] = useState(null);


    const navigate = useNavigate();



    const handleSearch = () => {
        const value = searchTerm.toLowerCase();

        if (value.includes("gst") || value.includes("tax")) {
            navigate("/gst");
        }
        else if (value.includes("company") || value.includes("registration")) {
            navigate("/company-registration");
        }
        else if (value.includes("trademark") || value.includes("ip")) {
            navigate("/trademark");
        }
        else if (value.includes("import") || value.includes("export")) {
            navigate("/import-export");
        }
        else {
            navigate("/search-results");
        }
    };

    const toggleMenu = (menu) => {
        setOpenMenu(openMenu === menu ? null : menu);
        setOpenSubMenu(null); // reset submenu
    };

    const toggleSubMenu = (submenu) => {
        setOpenSubMenu(openSubMenu === submenu ? null : submenu);
    };

    return (
        <header>

            {/* ================= TOP NAV ================= */}
            <div className="main-nav">



                {/* LOGO (CENTER DESKTOP / LEFT MOBILE) */}
                <div className="logo" onClick={window.scrollTo(0, 0)}>
                    <Link to="/">
                        <img src={logo} alt="E-Advisor Solution Company Logo" />
                    </Link>
                </div>

                {/* LEFT (DESKTOP ONLY) */}
                <div className="left">

                    <span className="contact-item" >
                        <a href="mailto:Support@e-advisorssolution.com" className="contact-item">
                            <FaEnvelope className="contact-icon email" />
                            Support@e-advisorssolution.com
                        </a>
                    </span>

                    <span className="contact-item">
                        <a href="tel:9506487032" className="contact-item">
                            <FaPhone className="contact-icon phone" />
                            9218103915
                        </a>
                    </span>



                </div>


                {/* RIGHT (DESKTOP ONLY) */}
                <div className="right">
                    <div className="search-bar">
                        <input
                            type="text"
                            placeholder="Search services..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") handleSearch();
                            }}
                        />

                        <FaSearch className="search-icon" onClick={handleSearch} />
                    </div>
                    {/* 
                    <div
                        className="profile-btn"
                        onClick={() => {
                            const link = document.createElement("a");
                            link.href = { companypdf }//"/pdf/CompanyProfile_E-Advisor.pdf"; // ✅ correct path
                            link.download = "CompanyProfile_E-Advisor.pdf";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }}
                    >
                        <i className="fa-thin fa-arrow-down"></i> Company Profile
                    </div> */}
                    <div
                        className="profile-btn"
                        onClick={async () => {

                            try {

                                // API CALL
                                const response = await axios.get(
                                    `${HostApi()}/api/Advisor/download`,
                                    {
                                        responseType: "blob"
                                    }
                                );

                                // CREATE FILE URL
                                const url = window.URL.createObjectURL(
                                    new Blob([response.data])
                                );

                                // CREATE DOWNLOAD LINK
                                const link = document.createElement("a");

                                link.href = url;

                                link.setAttribute(
                                    "download",
                                    "CompanyProfile_E-Advisor.pdf"
                                );

                                // APPEND LINK
                                document.body.appendChild(link);

                                // DOWNLOAD FILE
                                link.click();

                                // REMOVE LINK
                                document.body.removeChild(link);

                                // REMOVE URL
                                window.URL.revokeObjectURL(url);

                            } catch (error) {

                                console.log("Download Error", error);

                            }

                        }}
                    >
                        <i className="fa-thin fa-arrow-down"></i>

                        Company Profile
                    </div>

                    <div className="icons">
                        <a href="https://api.whatsapp.com/send?phone=+919218103915&text=Hello%20Advisor%20Solution">
                            <FaWhatsapp className="icon whatsapp" />
                        </a>
                        <FaFacebook className="icon facebook" />
                        <a
                            href="https://www.instagram.com/solutioneadvisors/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaInstagram className="icon instagram" />
                        </a>
                        <FaTwitter className="icon x" />
                        <FaLinkedin className="icon linkedin" />
                    </div>
                </div>

                {/* HAMBURGER (MOBILE ONLY) */}
                <button
                    className="hamburger"
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    {menuOpen ? "✖" : "☰"}
                </button>

            </div>

            {/* ================= MENU ================= */}
            <ul className={`menu ${menuOpen ? "active" : ""}`}>

                {/* MOBILE SEARCH */}
                <li className="mobile-search">
                    <input type="text" placeholder="Search services..." />
                </li>

                {/* BUSINESS SETUP DROPDOWN */}
                <li
                    onMouseEnter={() => setOpenMenu("business")}
                    onMouseLeave={() => {
                        setOpenMenu(null);
                        setOpenSubMenu(null);
                    }}
                >
                    Business Setup ▾

                    {openMenu === "business" && (
                        <ul className="submenu">

                            {/* ENTITY REGISTRATION */}
                            <li
                                onClick={() => {
                                    //e.stopPropagation();
                                    toggleSubMenu("entity");
                                }}
                            >
                                Entity Registration ▾

                                {openSubMenu === "entity" && (
                                    <ul className="submenu-level2">
                                        <li
                                            onClick={() => {
                                                navigate("/company-registration");
                                                setMenuOpen(false);
                                                setOpenMenu(null);
                                                setOpenSubMenu(null);
                                                window.scrollTo(0, 0);
                                            }}
                                        >
                                            Company Registration
                                        </li>
                                        <li onClick={() => {
                                            navigate("/private-limited");
                                            setMenuOpen(false);
                                            setOpenMenu(null);
                                            setOpenSubMenu(null);
                                            window.scrollTo(0, 0);
                                        }}>
                                            Private Limited Company
                                        </li>
                                        <li onClick={() => {
                                            navigate("/partnership");
                                            setMenuOpen(false);
                                            setOpenMenu(null);
                                            setOpenSubMenu(null);
                                            window.scrollTo(0, 0);
                                        }}>
                                            Partnership Firm Registration
                                        </li>
                                        <li onClick={() => {
                                            navigate("/llp");
                                            setMenuOpen(false);
                                            setOpenMenu(null);
                                            setOpenSubMenu(null);
                                            window.scrollTo(0, 0);
                                        }}>
                                            Limited Liability Partnership
                                        </li>
                                        <li onClick={() => {
                                            navigate("/opc");
                                            setMenuOpen(false);
                                            setOpenMenu(null);
                                            setOpenSubMenu(null);
                                            window.scrollTo(0, 0);
                                        }}>
                                            One Person Company (OPC)
                                        </li>
                                        <li onClick={() => {
                                            navigate("/section-8");
                                            setMenuOpen(false);
                                            setOpenMenu(null);
                                            setOpenSubMenu(null);
                                            window.scrollTo(0, 0);
                                        }}>
                                            Section 8 Company
                                        </li>
                                        <li onClick={() => {
                                            navigate("/society");
                                            setMenuOpen(false);
                                            setOpenMenu(null);
                                            setOpenSubMenu(null);
                                            window.scrollTo(0, 0);
                                        }}>
                                            Society Registration
                                        </li>
                                        <li onClick={() => {
                                            navigate("/ngo");
                                            setMenuOpen(false);
                                            setOpenMenu(null);
                                            setOpenSubMenu(null);
                                            window.scrollTo(0, 0);
                                        }}>
                                            NGO Registration
                                        </li>
                                        <li onClick={() => {
                                            navigate("/public-limited");
                                            setMenuOpen(false);
                                            setOpenMenu(null);
                                            setOpenSubMenu(null);

                                        }}>
                                            Public Limited Company
                                        </li>
                                        <li onClick={() => {
                                            navigate("/sole");
                                            setMenuOpen(false);
                                            setOpenMenu(null);
                                            setOpenSubMenu(null);
                                            window.scrollTo(0, 0);
                                        }}>
                                            Sole Proprietorship
                                        </li>
                                    </ul>
                                )}
                            </li>
                            {/* Company Closure */}
                            <li
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleSubMenu("Closure");
                                }}
                            >
                                Company Closure ▾

                                {openSubMenu === "Closure" && (
                                    <ul className="submenu-level2">

                                        <li onClick={() => {
                                            navigate("/llp-closure");
                                            setMenuOpen(false);
                                            setOpenMenu(null);
                                            setOpenSubMenu(null);
                                            window.scrollTo(0, 0);
                                        }}>
                                            LLP Closure
                                        </li>

                                        <li onClick={() => {
                                            navigate("/opc-closure");
                                            setMenuOpen(false);
                                            setOpenMenu(null);
                                            setOpenSubMenu(null);
                                            window.scrollTo(0, 0);
                                        }}>
                                            OPC Closure
                                        </li>

                                        <li onClick={() => {
                                            navigate("/private-limited-closure");
                                            setMenuOpen(false);
                                            setOpenMenu(null);
                                            setOpenSubMenu(null);
                                            window.scrollTo(0, 0);
                                        }}>
                                            Private Limited Closure
                                        </li>

                                        <li onClick={() => {
                                            navigate("/section-8-closure");
                                            setMenuOpen(false);
                                            setOpenMenu(null);
                                            setOpenSubMenu(null);
                                            window.scrollTo(0, 0);
                                        }}>
                                            Section 8 Closure
                                        </li>

                                    </ul>
                                )}
                            </li>
                            {/* HOSPITALITY */}
                            {/* <li
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleSubMenu("hospitality");
                                }}
                            >
                                Hospitality Business Setup ▾

                                {openSubMenu === "hospitality" && (
                                    <ul className="submenu-level2">

                                        <li onClick={(e) => { e.stopPropagation(); navigate("/hotel"); }}>
                                            Hotel Registration
                                        </li>

                                        <li onClick={(e) => { e.stopPropagation(); navigate("/guest-house"); }}>
                                            Guest House
                                        </li>

                                        <li onClick={(e) => { e.stopPropagation(); navigate("/homestay"); }}>
                                            HomeStay
                                        </li>

                                        <li onClick={(e) => { e.stopPropagation(); navigate("/restaurant"); }}>
                                            Restaurant Registration
                                        </li>

                                        <li onClick={(e) => { e.stopPropagation(); navigate("/frro"); }}>
                                            FRRO Registration
                                        </li>

                                        <li onClick={(e) => { e.stopPropagation(); navigate("/eating-house"); }}>
                                            Eating House Licence
                                        </li>

                                    </ul>
                                )}
                            </li> */}
                            {/* FSSAI */}
                            {/* <li
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleSubMenu("fssai");
                                }}
                            >
                                FSSAI Licence ▾

                                {openSubMenu === "fssai" && (
                                    <ul className="submenu-level2">
                                        <li>FSSAI Basic Registration</li>
                                        <li>FSSAI State License</li>
                                        <li>FSSAI Central License</li>
                                        <li>FSSAI Renewal</li>
                                    </ul>
                                )}
                            </li> */}

                            {/* NGO */}
                            {/* <li
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleSubMenu("ngo");
                                }}
                            >
                                NGO Registration ▾

                                {openSubMenu === "ngo" && (
                                    <ul className="submenu-level2">
                                        <li>Trust Registration</li>
                                        <li>Society Registration</li>
                                        <li>Section 8 Company</li>
                                        <li>NGO Compliance</li>
                                    </ul>
                                )}
                            </li> */}

                            {/* HEALTHCARE */}
                            {/* <li
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleSubMenu("health");
                                }}
                            >
                                Healthcare Business ▾

                                {openSubMenu === "health" && (
                                    <ul className="submenu-level2">
                                        <li>Clinic Registration</li>
                                        <li>Hospital License</li>
                                        <li>Pharmacy License</li>
                                        <li>Diagnostic Center Setup</li>
                                    </ul>
                                )}
                            </li> */}

                            {/* FIRE NOC */}
                            {/* <li
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleSubMenu("fire");
                                }}
                            >
                                Fire NOC ▾

                                {openSubMenu === "fire" && (
                                    <ul className="submenu-level2">
                                        <li>Fire NOC Application</li>
                                        <li>Fire Safety Audit</li>
                                        <li>Fire Renewal</li>
                                    </ul>
                                )}
                            </li> */}

                            {/* SUBSIDY */}
                            {/* <li
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleSubMenu("subsidy");
                                }}
                            >
                                Subsidy ▾

                                {openSubMenu === "subsidy" && (
                                    <ul className="submenu-level2">
                                        <li>MSME Subsidy</li>
                                        <li>Startup Subsidy</li>
                                        <li>Export Incentives</li>
                                    </ul>
                                )}
                            </li> */}

                            {/* STARTUP INDIA */}
                            {/* <li
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleSubMenu("startup");
                                }}
                            >
                                Startup India ▾

                                {openSubMenu === "startup" && (
                                    <ul className="submenu-level2">
                                        <li>DPIIT Registration</li>
                                        <li>Startup Certification</li>
                                        <li>Tax Benefits</li>
                                    </ul>
                                )}
                            </li> */}

                        </ul>
                    )}
                </li>

                <li
                    onMouseEnter={() => setOpenMenu("registrations")}
                    onMouseLeave={() => {
                        setOpenMenu(null);
                        setOpenSubMenu(null);
                    }}
                >
                    Registrations ▾

                    {openMenu === "registrations" && (
                        <ul className="submenu">

                            <li
                                onClick={() => {
                                    navigate("/gst-registration");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                GST Registration
                            </li>

                            <li
                                onClick={() => {
                                    navigate("/iso-certification");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                ISO Certification
                            </li>

                            <li
                                onClick={() => {
                                    navigate("/msme-registration");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                MSME Registration
                            </li>

                            <li
                                onClick={() => {
                                    navigate("/pasar-registration");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                PASARA Registration
                            </li>

                            <li
                                onClick={() => {
                                    navigate("/professional-tax-registration");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                Professional Tax Registration
                            </li>

                        </ul>
                    )}
                </li>
                <li
                    onMouseEnter={() => setOpenMenu("importExport")}
                    onMouseLeave={() => {
                        setOpenMenu(null);
                        setOpenSubMenu(null);
                    }}
                >
                    Import Export ▾

                    {openMenu === "importExport" && (
                        <ul className="submenu">

                            <li
                                onClick={() => {
                                    navigate("/import-export-code");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                Import Export Code (IEC)
                            </li>

                            <li
                                onClick={() => {
                                    navigate("/us-fda");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                US FDA Registration
                            </li>

                            <li
                                onClick={() => {
                                    navigate("/rodtep-scheme");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                RoDTEP Scheme Assistance
                            </li>

                            <li
                                onClick={() => {
                                    navigate("/ad-code-registration");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                AD Code Registration
                            </li>

                            <li
                                onClick={() => {
                                    navigate("/apeda-registration");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                APEDA Registration
                            </li>

                            <li
                                onClick={() => {
                                    navigate("/lut-certificate");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                LUT Certificate Registration
                            </li>

                            <li
                                onClick={() => {
                                    navigate("/rcmc-registration");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                RCMC Registration
                            </li>

                        </ul>
                    )}
                </li>

                <li
                    onMouseEnter={() => setOpenMenu("compliance")}
                    onMouseLeave={() => {
                        setOpenMenu(null);
                        setOpenSubMenu(null);
                    }}
                >
                    Compliance & TAX ▾

                    {openMenu === "compliance" && (
                        <ul className="submenu">

                            <li
                                onClick={() => {
                                    navigate("/fssai-return-filing");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                FSSAI Return Filing
                            </li>

                            <li
                                onClick={() => {
                                    navigate("/GST-return-filing");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                GST Return Filing
                            </li>

                            <li
                                onClick={() => {
                                    navigate("/Income-tax-return");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                Income Tax Return
                            </li>

                            <li
                                onClick={() => {
                                    navigate("/ITR");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                ITR-U Form Filing
                            </li>

                            <li
                                onClick={() => {
                                    navigate("/TDS");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                TDS Return Filing
                            </li>

                            <li
                                onClick={() => {
                                    navigate("/annual-filing");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                Annual Filing
                            </li>
                            <li
                                onClick={() => {
                                    navigate("/acommerceaccounting");
                                    setMenuOpen(false);
                                    setOpenMenu(null);
                                    window.scrollTo(0, 0);
                                }}
                            >
                                E-commerce Accounting
                            </li>

                        </ul>
                    )}
                </li>
                <li
                    onMouseEnter={() => setOpenMenu("ipr")}
                    onMouseLeave={() => {
                        setOpenMenu(null);
                        setOpenSubMenu(null);
                    }}
                >
                    IPR Registrations ▾

                    {openMenu === "ipr" && (
                        <ul className="submenu">

                            <li onClick={() => {
                                navigate("/trademark");

                                setMenuOpen(false);
                                setOpenMenu(null);
                                setOpenSubMenu(null);
                                window.scrollTo(0, 0);
                            }}>
                                Trademark (™ / ®)
                            </li>

                            <li onClick={() => {
                                navigate("/copyright");
                                setMenuOpen(false);
                                setOpenMenu(null);
                                setOpenSubMenu(null);
                                window.scrollTo(0, 0);
                            }}>
                                Copyright (©)
                            </li>

                            <li onClick={() => {
                                navigate("/patent");
                                setMenuOpen(false);
                                setOpenMenu(null);
                                setOpenSubMenu(null);
                                window.scrollTo(0, 0);
                            }}>
                                Patent
                            </li>

                            {/* <li onClick={() => {
                                navigate("/design-registration");
                                setMenuOpen(false);
                                setOpenMenu(null);
                                setOpenSubMenu(null);
                                window.scrollTo(0, 0);
                            }}>
                                Design Registration
                            </li> */}

                            <li onClick={() => {
                                navigate("/gi-tag");
                                setMenuOpen(false);
                                setOpenMenu(null);
                                setOpenSubMenu(null);
                                window.scrollTo(0, 0);
                            }}>
                                GI Tag
                            </li>

                            <li onClick={() => {
                                navigate("/plant-variety");
                                setMenuOpen(false);
                                setOpenMenu(null);
                                setOpenSubMenu(null);
                                window.scrollTo(0, 0);
                            }}>
                                Plant Variety (PVPFR)
                            </li>

                            <li onClick={() => {
                                navigate("/semiconductor-layout");
                                setMenuOpen(false);
                                setOpenMenu(null);
                                setOpenSubMenu(null);
                                window.scrollTo(0, 0);
                            }}>
                                Semiconductor Layout
                            </li>

                        </ul>
                    )}
                </li>
                {/* <li>Tender</li> */}
                <li
                    onMouseEnter={() => setOpenMenu("more")}
                    onMouseLeave={() => {
                        setOpenMenu(null);
                        setOpenSubMenu(null);
                    }}
                > More ▾

                    {openMenu === "more" && (
                        <ul className="submenu">

                            <li onClick={() => {
                                navigate("/web-development");

                                setMenuOpen(false);
                                setOpenMenu(null);
                                setOpenSubMenu(null);
                                window.scrollTo(0, 0);
                            }}>
                                Web Development
                            </li>

                        </ul>
                    )}

                </li>

            </ul>

        </header>
    );
};

export default Header;